// debug
import { debugAPI } from "./debug/debugAPI";

// book

import { postTransferKey } from "./book/postTransferKey";
import { putRestore } from "./book/putRestore";
import { usedBook } from "./book/usedBook";
import { validBook } from "./book/validBook";
import { validBooks } from "./book/validBooks";

// bookGroup
import { cancelBookGroup } from "./bookGroup/cancelBookGroup";
import { createBookGroup } from "./bookGroup/createBookGroup";
import { createBookGroupWithVoucher } from "./bookGroup/createBookGroupWithVoucher";
import { getMytickets } from "./bookGroup/getMytickets";
import { getMyticketDetail } from "./bookGroup/getMyticketDetail";
import { postTransfer } from "./bookGroup/postTransfer";
import { postStopSubscription } from "./bookGroup/postStopSubscription";
import { postCreateCouponBookGroup } from "./bookGroup/postCreateCouponBookGroup";
import { purchaseComplete } from "./bookGroup/purchaseComplete";
import { refundBookGroup } from "./bookGroup/refundBookGroup";

// frame
import { postFrames } from "./frame/postFrames";
import { putMamoruOnetimepass } from "./frame/putMamoruOnetimepass";
import { putMamoruQR } from "./frame/putMamoruQR";
import { validFrameWithCode } from "./frame/validFrameWithCode";
import { validFramesWithCode } from "./frame/validFramesWithCode";
import { validFrameWithQR } from "./frame/validFrameWithQR";
import { validFramesWithQR } from "./frame/validFramesWithQR";

//masterBookSet
import { getMasterBookSet } from "./masterBookSet/getMasterBookSet";
import { getMasterBookSets } from "./masterBookSets/getMasterBookSets";

//masterBook
import { getMasterBook } from "./masterBook/getMasterBook";
import { getVoucherMasterBook } from "./masterBook/getVoucherMasterBook";

// masterSheet
import { getSheetMenus } from "./masterSheet/getSheetMenus";

// pass
import { getPass } from "./pass/getPass";
import { getQrLink } from "./pass/getQrLink";
import { getQrString } from "./pass/getQrString";
import { getQrInfoForQrTicketGate } from "./pass/getQrInfoForQrTicketGate";
import { usedPasses } from "./pass/usedPasses";
import { validPasses } from "./pass/validPasses";

// sheet
import { getSheet } from "./sheet/getSheet";

// creditCard
import { getCardInfo } from "./creditCard/getCardInfo";

// user
import { deleteUser } from "./user/deleteUser";

// qr
import { postQRCodeSupport } from "./qr/postQRCodeSupport";

// MFITT
import { getVacancyInquiry } from "./MFITT/getVacancyInquiry";
import { getStationsForMFITT } from "./MFITT/getStationsForMFITT";
import { getMyLimitedExpressTicket } from "./MFITT/getMyLimitedExpressTicket";
import { getMyLimitedExpressTickets } from "./MFITT/getMyLimitedExpressTickets";
import { postBookingOrPurchase } from "./MFITT/postBookingOrPurchase";
import { postChangeMyTicket } from "./MFITT/postChangeMyTicket";
import { postRefundTicket } from "./MFITT/postRefundTicket";
import { putTicketingStatus } from "./MFITT/putTicketingStatus";
import { getCarNumberVacancyStatus } from "./MFITT/getCarNumberVacancyStatus";
import { getTicketPrice } from "./MFITT/getTicketPrice";
import { getTicketPriceForReserved } from "./MFITT/getTicketPriceForReserved";
import { getMyCoupons } from "./MFITT/getMyCoupons";
import { getCouponWithId } from "./MFITT/getCouponWithId";
import { getCouponWithTicketId } from "./MFITT/getCouponWithTicketId";
import { getPaymentMethods } from "./MFITT/getPaymentMethods";
import { getSpecialCarContent } from "./MFITT/getSpecialCarContent";

// DBS
import { deleteDbsReservation } from "./dbs/deleteDbsReservation"; // x-bks-sessionid必須
import { getDbsCouponTickets } from "./dbs/getDbsCouponTickets";
import { getDbsCycle } from "./dbs/getDbsCycle";
import { getDbsCyclePorts } from "./dbs/getDbsCyclePorts";
import { getDbsPark } from "./dbs/getDbsPark"; // x-bks-sessionid必須
import { getDbsReservation } from "./dbs/getDbsReservation"; // x-bks-sessionid必須
import { postDbsReservation } from "./dbs/postDbsReservation"; // x-bks-sessionid必須
import { postDbsUnlock } from "./dbs/postDbsUnlock"; // x-bks-sessionid必須
import { getDbsReportsForPast } from "./dbs/getDbsReportsForPast";
import { getDbsReportsForUsing } from "./dbs/getDbsReportsForUsing";

//Demand
import { getDemandArea } from "./demand/getDemandArea";
import { getDemandReservations } from "./demand/getDemandReservations";
import { getDemandToken } from "./demand/getDemandToken";
import { getDemandBusStops } from "./demand/getDemandBusStops";
import { getEbusReservation } from "./demand/getEbusReservation";
import { getEbusInfo } from "./demand/getEbusInfo";
import { postEbusTentativeReservation } from "./demand/postEbusTentativeReservation";
import { putDeleteReservation } from "./demand/putDeleteReservation";
import { putApproveReservation } from "./demand/putApproveReservation";
import { putDeclineEbusTentativeReservation } from "./demand/putDeclineEbusTentativeReservation";

// Notification
import { getNotifications } from "./notification/getNotifications";

// external Coupons
import { issueExternalCoupon } from "./externalCoupon/issueExternalCoupon";
import { retryIssuedExternalCoupon } from "./externalCoupon/retryIssuedExternalCoupon";
import {
  getExternalCoupons,
  getExternalCoupon,
  getMasterCoupon,
} from "./externalCoupon/getExternalCoupons";


// SBPS Payment
import { getPaymentMethodsForMasterBook } from "./sbps_payment/getPaymentMethodsForMasterBook";
import { getPaymentProcessInfo } from "./sbps_payment/getPaymentProcessInfo";

export default {
  debugAPI,
  postTransferKey,
  putRestore,
  usedBook,
  validBook,
  validBooks,
  cancelBookGroup,
  createBookGroup,
  createBookGroupWithVoucher,
  getMytickets,
  getMyticketDetail,
  postTransfer,
  postStopSubscription,
  postCreateCouponBookGroup,
  purchaseComplete,
  refundBookGroup,
  getSheetMenus,
  postFrames,
  putMamoruOnetimepass,
  putMamoruQR,
  validFrameWithCode,
  validFramesWithCode,
  validFrameWithQR,
  validFramesWithQR,
  getMasterBookSet,
  getMasterBookSets,
  getMasterBook,
  getVoucherMasterBook,
  getPass,
  getQrLink,
  getQrString,
  getQrInfoForQrTicketGate,
  usedPasses,
  validPasses,
  getSheet,
  getCardInfo,
  deleteUser,
  postQRCodeSupport,
  getVacancyInquiry,
  getStationsForMFITT,
  getMyLimitedExpressTicket,
  getMyLimitedExpressTickets,
  postBookingOrPurchase,
  postChangeMyTicket,
  postRefundTicket,
  putTicketingStatus,
  getCarNumberVacancyStatus,
  getTicketPrice,
  getTicketPriceForReserved,
  getMyCoupons,
  getCouponWithId,
  getCouponWithTicketId,
  getPaymentMethods,
  deleteDbsReservation,
  getDbsCouponTickets,
  getDbsCycle,
  getDbsCyclePorts,
  getDbsPark,
  getDbsReservation,
  postDbsReservation,
  postDbsUnlock,
  getDbsReportsForPast,
  getDbsReportsForUsing,
  getDemandArea,
  getDemandReservations,
  getDemandToken,
  getDemandBusStops,
  getEbusReservation,
  getEbusInfo,
  postEbusTentativeReservation,
  putDeleteReservation,
  putApproveReservation,
  putDeclineEbusTentativeReservation,
  getNotifications,
  issueExternalCoupon,
  retryIssuedExternalCoupon,
  getExternalCoupons,
  getExternalCoupon,
  getMasterCoupon,
  getPaymentMethodsForMasterBook,
  getPaymentProcessInfo,
  getSpecialCarContent,
};
